import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import BookingSteps, { STEPS_TYPE } from '@/organisms/booking-steps';
import RedirectToHome from '@/organisms/redirect-to-home';
import { useLocationsStore } from '@core/locations/store/locations';
import { useSettingsStore } from '@core/settings/store/settings';

const PackagesPage = () => {
  const { t } = useTranslation();
  const { isPackagesEnabled } = useSettingsStore();
  const { locations } = useLocationsStore();
  const router = useRouter();

  useEffect(() => {
    if (!isPackagesEnabled) {
      router.push(`/home?clientName=${router.query.clientName}`);
    }
  }, []);

  if (!isPackagesEnabled) return <RedirectToHome message={t('booking.notAllowedMeetingRoom')} />;

  return <BookingSteps stepsType={STEPS_TYPE.PACKAGES} locations={locations} />;
};

export default PackagesPage;
